export const V1_ADD_PRE_FILL_PASSENGERS = 'V1_ADD_PRE_FILL_PASSENGERS'

export default data => ({
  type: V1_ADD_PRE_FILL_PASSENGERS,
  data,
})
